export default class Device {
    static isMobile() {
        return window.innerWidth <= 700;
    }

    static isPwaInstalled() {
        return (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone);
    }
}